// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconLinkBroken = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '40',
      height: '40',
      viewBox: '0 0 40 40',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.452 17.139 8.729 20.86a7.383 7.383 0 0 0-2.175 5.27 7.418 7.418 0 0 0 2.253 5.302 7.418 7.418 0 0 0 5.303 2.253c2.033.015 3.88-.74 5.27-2.13l3.722-3.722m4.755-4.664 3.722-3.722a7.382 7.382 0 0 0 2.175-5.27 7.418 7.418 0 0 0-2.252-5.303A7.56 7.56 0 0 0 26.2 6.668c-1.988-.015-3.88.74-5.27 2.13l-3.723 3.722M14.509 25.7l11.168-11.168M8.894 8.695 7.05 6.851m8.246-1.404.302-3.039M2.87 15.136l3.15-.313m25.548 16.02 1.844 1.844m-8.246 1.404-.302 3.039m12.728-12.728-3.15.313',
      stroke: 'current',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconLinkBroken };
